import { Box, FormControl, FormLabel, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectJuryDetails } from '../../giftSlice';
import UserAvatar from '../../../../common/UserAvatar';
import { variants } from '../../../../variants/variants';
import { AlarmOnRounded, RateReviewRounded } from '@mui/icons-material';
import { format } from 'date-fns';
import { crash, takeoff } from '../../assets/index';
import { colors } from '../../utility/status';
import { useEffect, useState } from 'react';
import ViewFeedback from './ViewFeedback';

const FeedbackPreview = () => {
  const interview = useSelector(selectJuryDetails);
  const [openFeedback, setOpenFeedback] = useState(false);
  const [juryForm, setJuryForm] = useState(null);
  const handleOpenFeedback = (index) => {
    setOpenFeedback(true);
    setJuryForm({
      formDetails: interview.formDetails,
      feedback: interview.jury[index]?.feedbackForm,
      member: interview.juryDetails[index],
    });
  };
  const handleCloseFeedback = () => {
    setOpenFeedback(false);
    setJuryForm(null);
  };

  return (
    <Stack justifyContent={'flex-end'} sx={{ flex: 1, p: 1, border: 0 }}>
      {interview?.juryDetails && (
        <FormControl
          component='fieldset'
          sx={{ borderRadius: variants.boxRadius.MAIN, border: 1, borderColor: 'divider', p: 1 }}
        >
          <FormLabel component='legend'>
            <Typography sx={{ fontSize: variants.BODY }}>Jury members</Typography>
          </FormLabel>
          {interview?.juryDetails?.map((jury, index) => {
            let conclusion = interview.jury[index]?.feedbackForm?.conclusion || null;

            let conclusionImage = conclusion ? (
              <Stack direction={'row'} alignItems={'center'}>
                <img src={takeoff} style={{ width: 30, height: 30 }} />
                <Typography sx={{ fontSize: variants.BODY, color: colors.Pass, ml: 0.5 }}>Qualifies</Typography>{' '}
              </Stack>
            ) : (
              <Stack direction={'row'} alignItems={'center'}>
                <img src={crash} style={{ width: 30, height: 30 }} />
                <Typography sx={{ fontSize: variants.BODY, color: colors.Fail, ml: 0.5 }}>
                  Does not qualify
                </Typography>{' '}
              </Stack>
            );
            return (
              <Stack key={index} direction={'row'} alignItems={'center'} sx={{ my: 1 }}>
                <UserAvatar src={jury.employeePhotoPath} />
                <Typography sx={{ fontSize: variants.BODY, ml: 1 }}>{jury.empName}</Typography>
                {conclusion !== null && (
                  <Tooltip title='view feedback'>
                    <IconButton onClick={() => handleOpenFeedback(index)}>
                      <RateReviewRounded fontSize='small' />
                    </IconButton>
                  </Tooltip>
                )}
                <Typography sx={{ fontSize: variants.BODY, ml: 'auto', color: colors.Pending }}>
                  {conclusion === null ? 'feedback not given' : conclusionImage}
                </Typography>
              </Stack>
            );
          })}
        </FormControl>
      )}
      {interview?.juryMeetingDate && (
        <FormControl
          component='fieldset'
          sx={{ borderRadius: variants.boxRadius.MAIN, border: 1, borderColor: 'divider', p: 1, mt: 1 }}
        >
          <FormLabel component='legend'>
            <Typography sx={{ fontSize: variants.BODY }}>Meeting date & time</Typography>
          </FormLabel>
          <Stack direction={'row'} alignItems={'center'}>
            <AlarmOnRounded />
            <Typography sx={{ fontSize: variants.BODY, ml: 1 }}>
              {format(new Date(interview?.juryMeetingDate), 'PPpp')}
            </Typography>
          </Stack>
        </FormControl>
      )}
      <ViewFeedback open={openFeedback} handleClose={handleCloseFeedback} interview={juryForm} />
    </Stack>
  );
};

export default FeedbackPreview;
